
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/adding-to-cart",
      function () {
        return require("private-next-pages/adding-to-cart.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/adding-to-cart"])
      });
    }
  